<template>
  <div id="">
    <Header></Header>
    <Goback></Goback>
    <div class="btnparent">
      <a-button class="printbtn" @click="print" type="primary">打印</a-button>
    </div>
    <div id="printarea" ref="printarea">
      <h2>
        {{ reportName }}
        <br />
        报告统计
      </h2>
      <div id="reportarea" ref="reportarea">
        <!-- 整体统计 -->
        <!-- <div class="wholerate" ref="wholerate"></div> -->
        <!-- 部门统计 -->
        <div class="binechart" ref="departrate"></div>
        <!-- 性别合格率统计 -->
        <div class="binechart" ref="sexechart"></div>
        <!-- 理论统计 -->
        <div class="binechart" ref="theoryechart"></div>
        <!-- 灭火统计 -->
        <div class="binechart" ref="operechart"></div>
        <!-- 灭火动作统计 -->
        <div class="binechart" ref="outfireechart" v-if="isShow"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "@/Axios";
import utils from "@/utils";
import Header from "@/components/Header/Header";
import Goback from "@/components/Goback/Goback";
import { downloadPDF } from "@/utils/htmlToPdf";
import { printOut } from "@/utils/pdf";

export default {
  name: "Reportpage",
  components: {
    Header,
    Goback,
  },
  data() {
    return {
      isShow: false,
      url: {
        reportdata: "/repcomposer/repComposer/list", //获取报告数据
        operrate: "/statistics/practice", //实操统计
        sexrate: "/statistics/sex", //性别合格率统计
        // theoryrate: "/statistics/theory", //理论成绩统计
        firerate: "/statistics/fire", //灭火统计
        // departrate: "/statistics/department", //部门统计
        pagerate: "/statistics/info", //首页信息
        trainarrange: "/repcomposer/repComposer/report",
      },
      bartitle: "部门合格率统计",
      keyarr: [],
      imgUrls: {},
      webUrl: [],
      urllist: {},
      reportName: "", //报告名称
      websteponeimgs: [],
      phonesteponeimgs: [],
      websteptwoimgs: [],
      phonesteptwoimgs: [],
      //   phonesteponeimgs:[],
      phoneUrl: {},
      type: "",
    };
  },
  created() {
    // if (document.documentElement.clientWidth > 640) {
    //   this.type = "webUrllist";
    // } else {
    //   // require('./style/mobile.scss');
    //   this.type = "phoneUrllist";
    // }
  },
  mounted() {
    // var that = this;
    console.log("****************", this.$route.query);
    this.reportName =
      this.$route.query.universityId_dictText +
      "——" +
      this.$route.query.departmentName;
    this.getbardata();
  },

  methods: {
    // 请求部门数据
    getbardata() {
      var that = this;
      var xdata = [];
      var ydata = [];
      var tabledata = [];
      Axios.get(this.url.trainarrange, {
        params: {
          activeCode: this.$route.query.activeCode,
          departmentId: this.$route.query.departmentId || 0,
          universityId: this.$route.query.universityId,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          var records = res.data.result.records;
          // this.reportdata = res.data.result.records;
          // var
          records.map((item) => {
            // 整体统计
            var data = item.visualData || item.originalData;
            data = JSON.parse(data);
            if (item.step == 2) {
              console.log(data);
              that.draw(
                that.$refs.departrate,
                "部门合格统计",
                that.bindeparthandle(data)
              );
            }
            if (item.step == 3) {
              that.draw(
                that.$refs.theoryechart,
                "理论统计",
                that.bindatahandle(data)
              );
            }
            if (item.step == 4) {
              that.draw(
                that.$refs.sexechart,
                "性别合格率统计",
                that.binsexdatahandle(data)
              );
            }
            if (item.step == 5) {
              that.draw(
                that.$refs.operechart,
                "灭火统计",
                that.bindatahandle(data)
              );
            }
            if (item.step == 6) {
              if (data.length !== 0) {
                this.isShow = true
              }
              that.drawbar(
                that.$refs.outfireechart,
                "灭火动作合格率统计",
                that.baroutfiredatahandle(data)[0],
                that.baroutfiredatahandle(data)[1]
              );
            }
          });
        }
      });
    },
    // 柱状图
    drawbar(element, titletext, xdata, ydata) {
      // console.log(xdata);
      var mychart = this.$echarts.init(element);
      mychart.setOption({
        title: {
          text: titletext,
          left: "50%",
          textAlign: "center",
        },
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: "{b}<br/>{a}:{c}%",
        },
        grid: {
          left: "8%",
          right: "8%",
          bottom: "3%",
          containLabel: true,
        },
        yAxis: [
          {
            type: "value",
            name: "合格率%",
            // yAxis.nameTextStyle. verticalAlign
          },
        ],
        xAxis: [
          {
            type: "category",
            name: "动作",
            data: xdata,
            axisLabel: {
              interval: 0,
              rotate: 50,
            },
            // nameRotate:"90",
            // axisLabel:{
            // formatter:function(value){
            //       return value.split("").join("\n");
            // }
            // },
            nameGap: 0,
            axisTick: {
              alignWithLabel: true,
            },
            // nameLocation: "center",
            // nameTextStyle. fontWeight
          },
        ],
        series: [
          {
            name: "合格率",
            type: "bar",
            // formatter: "{a}：{c}",
            barWidth: "30%",
            data: ydata,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  // rotate:90,
                  // align:'left',
                  // verticalAlign:'middle',
                  // position: "insideBottom",
                  formatter: "{c}%",
                  position: "top",
                  textStyle: {
                    color: "red ",
                    fontWeight: "blod",
                    fontSize: "20px",
                  },
                },
              },
            },
          },
        ],
      });
    },
    // 饼图
    draw(dom, bintitle, data) {
      // console.log(dom);
      var mychart = this.$echarts.init(dom);
      mychart.setOption({
        baseOption: {
          color:['gray','green','blue','red','#87cefa','#da70d6','#32cd32','#6495ed',
            '#ff69b4','#ba55d3','#cd5c5c','#ffa500','#40e0d0',
            '#1e90ff','#ff6347','#7b68ee','#00fa9a','#ffd700',
            '#6699FF','#ff6666','#3cb371','#b8860b','#30e0e0'],
          title: {
            text: bintitle,
            left: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c} ({d}%)",
          },
          legend: {
            // orient: 'vertical',
            // top: 'middle',
            bottom: 10,
            left: "center",
            selectedMode: false, //取消图例上的点击事件
          },
          series: [
            {
              type: "pie",
              radius: "65%",
              center: ["50%", "50%"],
              selectedMode: "single",
              data: data,

              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    formatter: "{b} : {c} ({d}%)",
                  },
                  lableLine: { show: true },
                },
              },
            },
          ],
        },
        media: [
          {
            query: {
              maxWidth: 500,
            },
            option: {
              color:['gray','green','blue','red','#87cefa','#da70d6','#32cd32','#6495ed',
            '#ff69b4','#ba55d3','#cd5c5c','#ffa500','#40e0d0',
            '#1e90ff','#ff6347','#7b68ee','#00fa9a','#ffd700',
            '#6699FF','#ff6666','#3cb371','#b8860b','#30e0e0'],
              title: {
                text: bintitle,
                left: "center",
              },
              tooltip: {
                trigger: "item",
                formatter: "{b} : {c} ({d}%)",
              },
              legend: {
                // orient: 'vertical',
                // top: 'middle',
                bottom: 10,
                left: "center",
                selectedMode: false, //取消图例上的点击事件
              },
              series: [
                {
                  type: "pie",
                  radius: "25%",
                  center: ["50%", "50%"],
                  selectedMode: "single",
                  data: data,

                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                  itemStyle: {
                    normal: {
                      label: {
                        show: true,
                        formatter: "{b} : {c} ({d}%)",
                      },
                      lableLine: { show: true },
                    },
                  },
                },
              ],
            },
          },
        ],
      });
    },
    // 性别饼图数据处理
    binsexdatahandle(data) {
      var arr = [];
      data.map((item) => {
        var obj = {};
        obj.value = item.合格;
        obj.name = item.性别;
        arr.push(obj);
      });
      return arr;
    },
    // 饼图整体统计数据处理
    // binwholedatahandle(data) {
    //   var arr = []
    //   var obj_1 = { value: data[0].关联有效人数, name: '关联有效人数' }
    //   var obj_2 = { value: data[0].系统无关联人数, name: '系统无关联人数' }
    //   var obj_3 = { value: data[0].系统记录无效人数, name: '系统记录无效人数' }
    //   return [obj_1, obj_2, obj_3]
    // },
    // 灭火动作数据处理
    outfiredatahandle(data) {
      var xdata = [];
      var ydata = [];
      data.map((item) => {
        // obj = {}
        xdata.push(item._id);
        ydata.push((item.per * 100).toFixed(1));
      });
      return [xdata, ydata];
    },
    // 灭火动作柱状图数据处理
    baroutfiredatahandle(data) {
      var xdata = [];
      var ydata = [];
      xdata.push();
      data.map((item) => {
        xdata.push(item._id);
        ydata.push((item.per * 100).toFixed(1));
      });
      return [xdata, ydata];
    },
    // 其他饼图数据处理
    bindatahandle(data) {
      if (data[0].rateMap) {
        delete data[0].rateMap
      }
      var arr = [];
      for (var key in data[0]) {
        var obj = {};
        obj.value = data[0][key];
        obj.name = key;
        arr.push(obj);
      }
      return arr;
    },
    // 单个部门的统计饼图数据处理
    bindeparthandle(data) {
      console.log(data);
      var result = [
        { value: data[0].合格, name: "合格" },
        { value: data[0].不及格, name: "不及格" },
      ];
      console.log(result);
      return result;
    },
    // 打印
    print() {
      window.scrollTo(0, 0);
      console.log("+++++");
      downloadPDF(this.$refs.printarea, this.reportName + "报告统计");
    },
  },
};
</script>
<style scoped>
/* .btnarea {
  height: 100px;
  line-height: 100px;
  display: flex;
  justify-content: space-around;
  align-items: center;
} */
h2 {
  font-weight: bold;
  font-size: 20px;
  padding-top: 100px;
  /* display: block; */
  /* mar */
  /* height: 400px;
  line-height: 400px; */
  /* margin-top: 500px; */
}
.btnparent {
  overflow: hidden;
}
.printbtn {
  float: left;
  margin-left: 5vw;
  /* margin-left: 10vw; */
}
#reportarea {
  /* border-top: 1px solid black; */
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}
#reportarea > div {
  margin-top: 5vw;
  width: 45%;
  height: 35vw;
}
@media screen and (max-width: 768px) {
  #reportarea {
    border-top: 1px solid black;
  }
  #reportarea > div {
    width: 90vw;
    height: 60vh;
    margin: 10px 5vw;
  }
  /* #reportarea > div:nth-of-type(2n-1) {
    margin-top: 1vw;
  } */
  .btnarea {
    height: 50vh;
    /* line-height: 100px; */
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    align-items: center;
  }
  .setp_img {
    width: 100vw;
    height: 70vw;
    margin: 0;
  }
  .setp_img img {
    width: 100%;
    height: 100%;
  }
  .departrate {
    width: 100vw;
    height: 70vw;
  }
  .binechart {
    width: 100vw;
    height: 70vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Reportpage/Reportpage.vue